import * as Sentry from '@sentry/react';

import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { environmentAwareConfig } from './environmentAwareConfig';

const isProd = import.meta.env.PROD;

export const sentrySetup = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: environmentAwareConfig.sentryEnv,
    enabled: isProd,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: import.meta.env.VITE_SENTRY_RELEASE || 'git',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),

      Sentry.httpClientIntegration({
        failedRequestTargets: [/api\/.*/],
      }),
      Sentry.extraErrorDataIntegration(),
    ],
  });
};
